import { withRouter } from 'react-router';
import Dashboard from './Dashboard';

export default withRouter(Dashboard);
